var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNavHomeBold = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7996 4.66669C9.86252 4.67053 7.82546 4.74096 6.53312 6.0333C5.24078 7.32564 5.17034 9.3627 5.1665 13.2998H9.75245C9.42488 12.8906 9.18012 12.408 9.04666 11.8741C8.54429 9.86467 10.3645 8.04447 12.374 8.54684C12.9078 8.68031 13.3904 8.92506 13.7996 9.25264V4.66669Z",
    fill: "url(#paint0_linear_3539_2656)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1665 14.6998C5.17034 18.6369 5.24078 20.674 6.53312 21.9663C7.82546 23.2586 9.86252 23.3291 13.7996 23.3329V15.9819C13.072 17.4353 11.569 18.4331 9.83295 18.4331C9.44635 18.4331 9.13295 18.1197 9.13295 17.7331C9.13295 17.3465 9.44635 17.0331 9.83295 17.0331C11.2673 17.0331 12.4691 16.0376 12.7851 14.6998H5.1665Z",
    fill: "url(#paint1_linear_3539_2656)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1996 23.3329C19.1367 23.3291 21.1738 23.2586 22.4661 21.9663C23.7585 20.674 23.8289 18.6369 23.8327 14.6998H16.2141C16.5301 16.0376 17.7319 17.0331 19.1663 17.0331C19.5529 17.0331 19.8663 17.3465 19.8663 17.7331C19.8663 18.1197 19.5529 18.4331 19.1663 18.4331C17.4303 18.4331 15.9273 17.4353 15.1996 15.9819V23.3329Z",
    fill: "url(#paint2_linear_3539_2656)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8327 13.2998C23.8289 9.3627 23.7585 7.32564 22.4661 6.0333C21.1738 4.74096 19.1367 4.67053 15.1996 4.66669V9.25264C15.6088 8.92506 16.0914 8.68031 16.6253 8.54684C18.6347 8.04447 20.4549 9.86467 19.9526 11.8741C19.8191 12.408 19.5744 12.8906 19.2468 13.2998H23.8327Z",
    fill: "url(#paint3_linear_3539_2656)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0344 9.90504C13.0718 10.1644 13.7996 11.0965 13.7996 12.1659V13.2998H12.6657C11.5963 13.2998 10.6642 12.572 10.4049 11.5346C10.1588 10.5504 11.0503 9.659 12.0344 9.90504Z",
    fill: "url(#paint4_linear_3539_2656)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1996 12.1659V13.2998H16.3335C17.4029 13.2998 18.335 12.572 18.5944 11.5346C18.8404 10.5504 17.949 9.659 16.9648 9.90504C15.9274 10.1644 15.1996 11.0965 15.1996 12.1659Z",
    fill: "url(#paint5_linear_3539_2656)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3539_2656",
    x1: 5.1665,
    y1: 4.66669,
    x2: 23.8327,
    y2: 23.3329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EFF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#199E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3539_2656",
    x1: 5.1665,
    y1: 4.66669,
    x2: 23.8327,
    y2: 23.3329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EFF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#199E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3539_2656",
    x1: 5.1665,
    y1: 4.66669,
    x2: 23.8327,
    y2: 23.3329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EFF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#199E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3539_2656",
    x1: 5.1665,
    y1: 4.66669,
    x2: 23.8327,
    y2: 23.3329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EFF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#199E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3539_2656",
    x1: 5.1665,
    y1: 4.66669,
    x2: 23.8327,
    y2: 23.3329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EFF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#199E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3539_2656",
    x1: 5.1665,
    y1: 4.66669,
    x2: 23.8327,
    y2: 23.3329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EFF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#199E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107300"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNavHomeBold, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NavHomeBold.effcba8f.svg";
export { ForwardRef as ReactComponent };